import React, { useState, useEffect } from "react";
import { DebounceInput } from "react-debounce-input";
import {
  CompanyOffice,
  ListSort,
  PaginatedApiResponse,
  useOutsideClick,
} from "../../../core";
import { useDataLoader } from "react-remote-data-hooks";
import api from "../../../api";
import '../../../styles/global-search.scss'

type DataItem = {
  tenantsName: string;
  tenantsID: number;
};

interface CustomProps {
  placeholder?: string;
  setSelectedValues?: (item: { tenantsName: string; tenantsID: number; }[]) => void;
  selectedValues?: DataItem[]
}

const MultiSelectAutoComplete = (props: CustomProps) => {
  const [searchText, setSearchText] = useState<string>("");
  const [selectedValues, setSelectedValues] = useState<DataItem[]>(props?.selectedValues || []);
  const [showDropDown, setShowDropDown] = useState(false);

  const ref = React.useRef<HTMLDivElement>(null);

  useOutsideClick(ref, () => {
    setShowDropDown(false);
  });

  const { data: searchResults, loading, loaded, reload } = useDataLoader<any>(
    (searchTerm: string | undefined,
      currentPage: number,
      searchOrder?: ListSort
    ) =>
      searchTerm ? api.company.getCompanyList({
        page: 1,
        query: searchTerm,
        sortBy: 'createdAt',
        // sortOrder: DESC,
        perPage: 20,
      }) : undefined,
    [searchText]
  );


  useEffect(() => {
    if (loaded) {
      reload(searchText);
      setShowDropDown(true);
    }
  }, [searchText]);

  const handleResultSelect = (selectedItem: DataItem) => {
    // setSelectedValues([...selectedValues, selectedItem]);
    setSearchText("");
    setShowDropDown(false);
    props.setSelectedValues?.([...(props?.selectedValues || []), selectedItem]);
  };

  const handleRemove = (valueToRemove: DataItem) => {   
    const updatedSelectedValues = props?.selectedValues?.filter(
      (value) => value !== valueToRemove
    );
    // setSelectedValues(updatedSelectedValues);
    props.setSelectedValues?.(updatedSelectedValues || []);
  };

  return (
    <div className="position-relative" ref={ref}>
      <div
        className="custom-dropdown__search  d-flex align-items-center  px-2 py-2 bg-transparent border"
        // style={{ backgroundColor: "#EEEEEE" }}
      >
        <div className="d-flex flex-wrap align-items-baseline">
          <ul className="mb-0 list-unstyled float-left">
            {props?.selectedValues?.map((value, index) => (
              <li
                className="d-inline-block bg-gray-300 font-xs font-weight-semibold px-2 py-1 mr-2"
                key={index}
                style={{ marginBottom: "2px" }}
              >
                {value.tenantsName}
                <span
                  style={{ cursor: "pointer", marginLeft: "5px" }}
                  onClick={() => handleRemove(value)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                  >
                    <path
                      d="M7.90751 0.0924882C7.78419 -0.0308293 7.58426 -0.0308295 7.46094 0.0924882L4 3.55343L0.539061 0.0924882C0.415743 -0.0308295 0.215806 -0.0308293 0.0924882 0.0924882C-0.0308293 0.215806 -0.0308295 0.415743 0.0924882 0.539061L3.55343 4L0.0924882 7.46094C-0.0308293 7.58426 -0.0308293 7.78419 0.0924882 7.90751C0.215806 8.03083 0.415743 8.03083 0.539061 7.90751L4 4.44657L7.46094 7.90751C7.58426 8.03083 7.78419 8.03083 7.90751 7.90751C8.03083 7.78419 8.03083 7.58426 7.90751 7.46094L4.44657 4L7.90751 0.539061C8.03083 0.415743 8.03083 0.215806 7.90751 0.0924882Z"
                      fill="#000"
                    />
                  </svg>
                </span>
              </li>
            ))}
          </ul>

          <DebounceInput
            className="font-xs font-weight-semibold bg-transparent border-0 float-left"
            minLength={3}
            debounceTimeout={300}
            placeholder={props?.placeholder || ''}
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
            style={{ height: "25px", width: "400px" }}
          />
        </div>
      </div>
      {showDropDown && loading && !loaded && searchText && (
        <div
          className="zone-dropdown-outer position-absolute left-0 right-0 bg-white"
          style={{ maxHeight: "370px", overflow: "auto" }}
        >
          <div key="1">
            <div className="align-items-center border-bottom cursor-pointer custom-dropdown__menu-item font-sm pb-0 text-center">
              Searching...
            </div>
          </div>
        </div>
      )}

      {showDropDown &&
        loaded &&
        searchText &&
        !!searchResults?.data?.length && (
          <div
            className="zone-dropdown-outer position-absolute left-0 right-0 bg-white"
            style={{ maxHeight: "370px", overflow: "auto" ,zIndex:999 }}
          >
            {searchResults?.data?.map((z: any, index: number) =>
              <div key={index + 3}>
                <div
                  className="font-sm pb-2 font-weight-semibold cursor-pointer"
                  key={index}
                  onClick={() =>
                    handleResultSelect({
                      tenantsName: z?.tenantsName,
                      tenantsID: z?.tenantsID,
                    })
                  }
                >
                  {z?.tenantsName || ''}
                </div>
              </div>
            )}
          </div>
        )}
    </div>
  );
};

export default MultiSelectAutoComplete;
